import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../components/navbar/navbar";
import { Modal } from "../../components/Modals/ModalComponent/Modal";

import { OTPInput } from "../../components/OTPInput/otp-input";
import Footer from "../../components/Footer/Footer";
import "./email-verification.css";
import { useNavigate } from "react-router-dom";
import { POST } from "../../utils/httpUtils";
import { LoaderContext } from "../../context/LoaderContext";
import { useContext } from "react";
import { Log } from "../../utils/genericUtils";

export function EmailVerificationPage() {
  const { showloader, hideloader } = useContext(LoaderContext);
  const router = useNavigate();

  const user = useRef(null);
  const registration_url_params = useRef("");
  const submit_button = useRef(null);
  const OTP_INPUT = useRef();
  const error_message = useRef(null);

  useEffect(() => {
    submit_button.current.disabled = true;

    // Parse the query string using URLSearchParams
    let params = new URLSearchParams(window.location.search);
    // Access the parameters
    let username = params.get("id");
    let isRegister = params.get("registered") ?? "";
    if (!username) {
      router("/");
    }

    if (isRegister.toLowerCase() === "true") {
      registration_url_params.current = "?registered=true";
    }

    user.current = username;
  }, []);

  function GetValue() {
    return OTP_INPUT.current.GetValue();
  }

  async function ResendCode() {
    showloader();
    let response = await POST("/resend-otp", { username: user.current, type: "verify_email" });
    Log("resend response :", response);
    hideloader();
  }

  async function SubmitCode() {
    showloader();
    let code = GetValue();
    let response = await POST("/verify-email", { username: user.current, code });
    Log("submit response :", response);
    hideloader();
    if (response.success) {
      if (response.isVerified) {
        router(`/email-verification-success${registration_url_params.current}`);
      } else {
        error_message.current = response.error.message;
      }
    }

    if (response.success === false) error_message.current = response.error.message;
    if (response.success === undefined) error_message.current = "Unkown Error Occured";
  }

  function OnChar() {
    if (GetValue().length === 7) {
      submit_button.current.disabled = false;
    } else {
      submit_button.current.disabled = true;
    }
  }

  function ShowErrorMessage() {
    if (error_message.current) {
      return <p className="error-message">*{error_message.current}</p>;
    }
  }

  const subText =
    "A six digit verification code should have been sent to your email address. If you cannot find it please use the resend button below.";

  return (
    <>
      <Navbar />
      <section className="register-page-bg">
        <Modal id="email-verification-modal" showDivider={true} header="Verify Your Email Address" message={subText} isActive={true} animate={false}>
          <OTPInput id={"email-verification-otp"} ref={OTP_INPUT} onKey={OnChar} />
          <div className="email-verification-controls">
            {ShowErrorMessage()}
            <button ref={submit_button} className="standard-button" onClick={SubmitCode}>
              Submit
            </button>
            <div className="modal-footnote-box">
              <p>didn't recieve a code?</p>
              <button onClick={ResendCode}>resend</button>
            </div>
          </div>
        </Modal>
      </section>
      <Footer />
    </>
  );
}
